import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import AuthenticatedApp from './components/AuthenticatedApp';
import { DataStore } from 'aws-amplify/datastore';
import './App.css';

function App() {
  // The Amplify Authenticator 'signOut' function may accept an optional param
  // signature; allow any arguments to keep type compatibility between versions
  const handleSignOut = async (signOut: ((...args: any[]) => void) | undefined) => {
    if (!signOut) return;
    await DataStore.stop();
    signOut();
  };

  return (
    <Authenticator
      signUpAttributes={['email']}
      loginMechanisms={['username']}
      socialProviders={[]}
    >
      {({ signOut, user }) => (
        <AuthenticatedApp user={user} signOut={() => handleSignOut(signOut)} />
      )}
    </Authenticator>
  );
}

export default App;
